<template>
  <div>
    <el-dialog
      ref="addEditViewDialog"
      v-dialogDrag
      :title="dialogTitle"
      :visible.sync="dialogVisible"
      class="h550_dialog abow_dialog"
      width="1200px"
      :before-close="modalClose"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      append-to-body
    >
      <el-form
        ref="dialogAddEditViewForm"
        :model="dialogAddEditViewForm"
        :rules="eventType==='view' ? null : dialogAddEditViewFormRules"
        class="add-edit-view-form"
        @submit.native.prevent
      >
        <div class="modal-box">
          <h3 class="modal-title">
            基础信息
          </h3>
          <div class="modal-row-box">
            <el-row :gutter="10">
              <el-col :span="6">
                <el-form-item label="省区">
                  <el-input
                    v-model="dialogAddEditViewForm.provinceName"
                    disabled
                  />
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="城市">
                  <el-input
                    v-model="dialogAddEditViewForm.cityName"
                    disabled
                  />
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="专卖证号">
                  <el-input
                    v-model="dialogAddEditViewForm.certificateNo"
                    disabled
                  />
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item
                  label="店名"
                  prop="storeName"
                >
                  <el-input
                    v-model="dialogAddEditViewForm.storeName"
                    disabled
                  >
                    <el-button
                      v-if="eventType !== 'view'"
                      slot="append"
                      icon="el-icon-search"
                      @click="dialogStoreVisible = true"
                    />
                  </el-input>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="地址">
                  <el-input
                    v-model="dialogAddEditViewForm.address"
                    disabled
                  />
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="实际店名">
                  <el-input
                    v-model="dialogAddEditViewForm.realStoreName"
                    disabled
                  />
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="实际地址">
                  <el-input
                    v-model="dialogAddEditViewForm.realAddress"
                    disabled
                  />
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item
                  label="申请日期"
                  prop="applyDate"
                >
                  <el-date-picker
                    v-model="dialogAddEditViewForm.applyDate"
                    type="date"
                    style="width: 100%;"
                    format="yyyy-MM-dd"
                    value-format="yyyy-MM-dd"
                    :disabled="eventType==='view'"
                  />
                </el-form-item>
              </el-col>
              <el-col
                v-if="eventType === 'view'"
                :span="6"
              >
                <el-form-item label="方案编号">
                  <el-input
                    v-model="dialogAddEditViewForm.schemeNo"
                    disabled
                  />
                </el-form-item>
              </el-col>
              <el-col
                v-if="eventType === 'view'"
                :span="6"
              >
                <el-form-item label="方案名称">
                  <el-input
                    v-model="dialogAddEditViewForm.schemeName"
                    disabled
                  />
                </el-form-item>
              </el-col>
              <el-col
                v-if="dialogAddEditViewForm.stopCertificateNo"
                :span="6"
              >
                <el-form-item label="停用专卖证号">
                  <el-input
                    v-model="dialogAddEditViewForm.stopCertificateNo"
                    disabled
                  />
                </el-form-item>
              </el-col>
              <el-col
                v-if="dialogAddEditViewForm.stopCertificateNo"
                :span="6"
              >
                <el-form-item label="停用店名">
                  <el-input
                    v-model="dialogAddEditViewForm.stopStoreName"
                    disabled
                  />
                </el-form-item>
              </el-col>
              <el-col
                v-if="dialogAddEditViewForm.stopCertificateNo"
                :span="6"
              >
                <el-form-item label="停用地址">
                  <el-input
                    v-model="dialogAddEditViewForm.stopAddress"
                    disabled
                  />
                </el-form-item>
              </el-col>
              <el-col
                v-if="dialogAddEditViewForm.stopCertificateNo"
                :span="6"
              >
                <el-form-item label="停用实际店名">
                  <el-input
                    v-model="dialogAddEditViewForm.stopRealStoreName"
                    disabled
                  />
                </el-form-item>
              </el-col>
              <el-col
                v-if="dialogAddEditViewForm.stopCertificateNo"
                :span="6"
              >
                <el-form-item label="停用实际地址">
                  <el-input
                    v-model="dialogAddEditViewForm.stopRealAddress"
                    disabled
                  />
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="10">
              <el-col :span="24">
                <el-form-item
                  label="申请说明"
                  prop="applyDescription"
                >
                  <el-input
                    v-model="dialogAddEditViewForm.applyDescription"
                    type="textarea"
                    maxlength="512"
                    :disabled="eventType==='view'"
                  />
                </el-form-item>
              </el-col>
            </el-row>
          </div>
        </div>
        <div class="modal-box">
          <h3 class="modal-title">
            备注信息
          </h3>
          <div class="modal-row-box">
            <el-row :gutter="10">
              <el-col :span="24">
                <el-form-item prop="remark">
                  <el-input
                    v-model="dialogAddEditViewForm.remark"
                    type="textarea"
                    maxlength="512"
                    placeholder="备注"
                    :disabled="eventType==='view'"
                  />
                </el-form-item>
              </el-col>
            </el-row>
          </div>
        </div>
      </el-form>

      <div
        slot="footer"
        class="dialog-footer"
      >
        <el-button
          v-if="eventType!=='view'"
          type="primary"
          @click="handleSave"
        >
          保存
        </el-button>
        <el-button @click="modalClose">
          关闭
        </el-button>
      </div>
    </el-dialog>
    <!-- 终端列表 -->
    <store-list-dialog
      :dialog-visible.sync="dialogStoreVisible"
      :city-id="selectCityId"
      dialog-title="终端信息"
      @selectedStoreFun="selectedStoreFun"
    />
  </div>
</template>
<script>
// dialog 拖拽
import dialogDragMixin from '@/mixin/dialogDragMixin'
// 选择终端
import storeListDialog from './storeListDialog'
// 终端恢复申请API
import { viewSchemeStoreVisitRestoreApplyApi, saveSchemeStoreVisitRestoreApplyApi } from '@/api/v2/schemeStoreVisitRestoreApply';

export default {
  components: { storeListDialog },
  mixins: [dialogDragMixin],
  props: {
    dialogTitle: {
      type: String,
      default: ''
    },
    eventType: {
      type: String,
      default: ''
    },
    dialogVisible: {
      type: Boolean,
      default: false
    },
    dataId: {
      type: Number,
      default: 0
    }
  },
  data () {
    return {
      expandMoreData: false,
      dialogAddEditViewForm: {},
      dialogAddEditViewFormRules: {
        applyDate: [{ required: true, message: '请选择申请日期', trigger: 'blur' }],
        storeName: [{ required: true, message: '请选择零售户', trigger: 'blur' }],
        applyDescription: [{ required: true, message: '请输入申请说明', trigger: 'blur' }, { max: 512, message: '最多输入512个字符', trigger: 'blur' }],
        remark: [{ max: 512, message: '最多输入512个字符', trigger: 'blur' }]
      },
      dialogStoreVisible: false,
    }
  },
  watch: {
    dialogVisible (val) {
      if (val) {
        let _this = this;

        _this.dialogAddEditViewForm = {
          provinceName: '',
          cityName: '',
          schemeName: '',
          schemeNo: '',
          certificateNo: '',
          storeName: '',
          applyStoreId: '',
          address: '',
          realStoreName: '',
          realAddress: '',
          stopCertificateNo: '',
          stopStoreName: '',
          stopAddress: '',
          stopRealStoreName: '',
          stopRealAddress: '',
          applyDate: '',
          applyDescription: '',
          remark: ''
        }
        if (_this.eventType !== 'add') {
          _this.loadSchemeStoreVisitRestoreApplyData();
        }

        _this.$nextTick(() => {
          _this.$refs.dialogAddEditViewForm.clearValidate()
        })
      }
    },
  },
  methods: {
    // 加载终端恢复申请数据
    loadSchemeStoreVisitRestoreApplyData () {
      let _this = this;
      viewSchemeStoreVisitRestoreApplyApi({ id: _this.dataId }).then((response) => {
        const { data } = response;
        for (let key in _this.dialogAddEditViewForm) {
          _this.dialogAddEditViewForm[key] = data[key]
        }
        _this.dialogAddEditViewForm.id = data.id;
      })
    },
    // 选择终端
    selectedStoreFun (store) {
      let _this = this;
      _this.dialogAddEditViewForm.applyStoreId = store.id
      _this.dialogAddEditViewForm.provinceName = store.provinceName
      _this.dialogAddEditViewForm.cityName = store.cityName
      _this.dialogAddEditViewForm.certificateNo = store.certificateNo
      _this.dialogAddEditViewForm.storeName = store.storeName
      _this.dialogAddEditViewForm.address = store.address
      _this.dialogAddEditViewForm.realStoreName = store.realStoreName
      _this.dialogAddEditViewForm.realAddress = store.realAddress
    },
    modalClose () {
      let _this = this;
      _this.$emit('update:dialogVisible', false);
      _this.imageFileList = [];
      _this.$refs.dialogAddEditViewForm.clearValidate();
    },
    // 新增|修改保存
    handleSave () {
      let _this = this;
      _this.$refs.dialogAddEditViewForm.validate(valid => {
        if (valid) {
          _this.$confirm((_this.eventType === 'add' ? '是否确定新增' : '是否确定修改') + '终端恢复申请信息', '系统提示', { confirmButtonText: '确定', cancelButtonText: '取消', type: 'warning', center: true }).then(async () => {
            
            saveSchemeStoreVisitRestoreApplyApi(_this.dialogAddEditViewForm).then(() => {
              _this.$message({ message: '保存成功', type: 'success' })
              _this.$emit('reloadData')
              _this.modalClose()
            }).catch(() => { })
          }).catch(() => { })
        }
      })
    },
  }
}
</script>
<style lang="scss" scoped>
.explain-tooltip {
  float: right;
  margin-top: 10px;
  margin-right: 15px;
  color: white;
  cursor: pointer;
}
</style>
